"use strict";

exports.onRouteUpdate = function () {
  // Don't track while developing.
  if (process.env.NODE_ENV === "production" && typeof fbq === "function") {
    fbq("track", "ViewContent");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-facebook-pixel/gatsby-browser.js
// module id = 1257
// module chunks = 231608221292675